// 🚨 Facture publique — totaux affichés : MÊME source que l'interne (montants persistés), recalcul depuis `items` seulement en repli.
export function calculerTotauxFacture(facture, items, rabaisMontant = 0) {
  const sousTotalItems = (items || []).reduce((s, it) => s + (it.montant || 0), 0);
  const rabaisAffiche = Math.max(0, Math.min(rabaisMontant || 0, sousTotalItems));
  const total = parseFloat(facture.montant_total);
  const cashHybride = Boolean(facture.v13_49_cash_hybride_applique) && facture.montant_avant_taxes && facture.montant_total;
  if (cashHybride) {
    const baseTaxable = parseFloat(facture.montant_avant_taxes);
    return { source: 'persiste_cash', sousTotal: baseTaxable + rabaisAffiche, baseTaxable, tps: parseFloat(facture.tps || (baseTaxable * 0.05)), tvq: parseFloat(facture.tvq || (baseTaxable * 0.09975)), total, rabaisAffiche };
  }
  if (total > 0) {
    // Montants persistés = ceux de la facture interne et du PDF (aucun recalcul différent). Items vides → on les affiche quand même.
    const baseTaxable = parseFloat(facture.montant_avant_taxes || facture.sous_total || (total / 1.14975));
    const tps = parseFloat(facture.tps ?? (baseTaxable * 0.05));
    const tvq = parseFloat(facture.tvq ?? (baseTaxable * 0.09975));
    return { source: 'persiste', sousTotal: baseTaxable + rabaisAffiche, baseTaxable, tps, tvq, total, rabaisAffiche };
  }
  const baseTaxable = sousTotalItems - rabaisAffiche;
  const tps = baseTaxable * 0.05; const tvq = baseTaxable * 0.09975;
  return { source: 'items', sousTotal: sousTotalItems, baseTaxable, tps, tvq, total: baseTaxable + tps + tvq, rabaisAffiche };
}
